import { PHONE, PHONE_HREF, EMAIL, SERVICES } from "../../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-3 lg:px-8">
      <div>
        <img src="/logo.jpg" alt="Pipe-Line UK" className="h-28 w-28 rounded-full" />
        <div className="mt-5 font-display text-2xl font-bold uppercase">Pipe-Line <span className="text-[#1E9BFF]">UK</span></div>
        <div className="font-mono text-xs uppercase tracking-widest text-neutral-500">Drainage & Utility Specialists</div>
      </div>
      <div>
        <div className="font-mono text-xs uppercase tracking-widest text-[#1E9BFF]">Services</div>
        <ul className="mt-5 space-y-3 text-sm text-neutral-400">
          {SERVICES.map((s) => <li key={s.title}><a href="#services" className="hover:text-white">{s.title}</a></li>)}
        </ul>
      </div>
      <div>
        <div className="font-mono text-xs uppercase tracking-widest text-[#1E9BFF]">Contact</div>
        <a href={PHONE_HREF} data-testid="footer-phone-link" className="mt-5 block font-display text-2xl font-bold hover:text-[#1E9BFF]">{PHONE}</a>
        <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="mt-2 block break-all text-neutral-400 hover:text-white">{EMAIL}</a>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 py-6 font-mono text-xs text-neutral-600 lg:px-8">© {new Date().getFullYear()} Pipe-Line UK. All rights reserved.</div>
    </div>
  </footer>
);
